import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";

export interface FixOptionsLinkProps<T extends { id: string; url?: string }> {
  direction?: "vertical" | "horizontal";
  options: Array<T>;
  renderer: (item: T) => React.ReactNode;
  active?: string | null;
  onUpdateActive?: (id: string) => void;
  part?: string;
}

export function FixOptionsLink<T extends { id: string; url?: string }>({
  direction = "vertical",
  options,
  renderer,
  active = null,
  onUpdateActive,
  part,
}: FixOptionsLinkProps<T>) {
  if (!options) return null;

  return (
    <div
      className={classNames(styles.root, styles[direction])}
      part={part}
      data-direction={direction}
    >
      {options.map((item) =>
        item.url ? (
          <a
            key={item.id}
            href={item.url}
            className={classNames(styles.option, {
              [styles.active]: item.id === active,
            })}
            onClick={(e) => {
              e.preventDefault();
              onUpdateActive?.(item.id);
            }}
          >
            {renderer(item)}
          </a>
        ) : (
          <div
            key={item.id}
            className={classNames(styles.option, {
              [styles.active]: item.id === active,
            })}
            onClick={(e) => {
              e.preventDefault();
              onUpdateActive?.(item.id);
            }}
          >
            {renderer(item)}
          </div>
        )
      )}
    </div>
  );
}

export default FixOptionsLink;

